import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('booklist').select().eq('companyId', companyId)

	if (error) {
		throw new Error(`Failed to fetch book list data: ${error.message}`)
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('booklist').select().eq('id', id)
	if (error) {
		throw new Error(`Failed to fetch book data: ${error.message}`)
	}
	return data
}

export async function addData(adata) {
	const companyId = getCompanyId()
	adata = { ...adata, companyId: companyId }
	const { data, error } = await supabase.from('booklist').insert(adata).select()

	if (error) {
		throw new Error(`Failed to add book: ${error.message}`)
	}
	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('booklist').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error(`Failed to update book: ${error.message}`)
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('booklist').delete().eq('id', id)
	if (error) {
		throw new Error(`Failed to delete book: ${error.message}`)
	}

	return data
}
